module.exports = __webpack_public_path__ + "img/clicksource.b9423234.png";